import { Component, ElementRef, OnInit } from '@angular/core';

import { Chart } from 'chart.js';
import { round, sumBy } from 'lodash';
import 'chartjs-plugin-doughnutlabel';

@Component({
  selector: 'app-cibil-scores',
  templateUrl: './cibil-scores.component.html',
  styleUrls: ['./cibil-scores.component.css']
})
export class CibilScoresComponent implements OnInit {

  data = {
    datasets: [{
      data: [720, 80]
    }],
    backgroundColor: ['rgba(255, 0, 0, 1)', 'rgba(255, 0, 0, 0.1)'],
    labels: [
      'Red',
      'Yellow',
    ]
  };

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.drawChart();

  }
  chart: any;

  // Donut chart

  drawChart() {
    // const context = this.elementRef.nativeElement.querySelector(`#doughNutCanvas`);
    const plugins: any = {};
    plugins.doughnutlabel = {
      labels: [{
        color: '#4db53e',
        text: 720,
        font: { size: '14', units: 'px', family: 'Lato, sans-serif', weight: 'bold' }
      }]
    };
    // new Chart(context, {
    //   type: 'doughnut',
    //   data: this.data,
    //   options: {
    //     legend: {
    //       display: false
    //     },
    //     plugins: plugins
    //   }
    // });
    const context = this.elementRef.nativeElement.querySelector(`#doughNutCanvas`);

    this.chart = new Chart(context, {
      type: 'doughnut',
      data: {
        labels: ['Data1', 'Data2'],
        datasets: [
          {
            data: [720, 80],
            backgroundColor: ['#4db53e', '#f9f9f9'],
            fill: false,
          },
        ]
      },
      options: {
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        cutoutPercentage: 70,
        rotation: -7.2 * Math.PI,
        plugins: plugins
      }
    });
  }


}
